const setting = {
  //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: '重庆电信职业学院 | 一网通办',
  //简写
  abbreviation: 'yiwu',
  publicPath: '/',
  //是否显示顶部进度条
  progressBar: true,
  //缓存路由的最大数量
  keepAliveMaxNum: 99,
  //加载时显示文字
  loadingText: '正在加载中...',
  //token名称
  tokenName: 'token',
  //token存储位置localStorage sessionStorage
  storage: 'sessionStorage',
  //token在localStorage、sessionStorage存储的key的名称
  tokenKeyName: 'baiyuan-tk',
  requestTimeout: 600000,
  contentType: "application/json;charset=UTF-8",
  //操作正常code，支持String、Array、int多种类型
  successCode: [200, 0],
  //登录失效code
  invalidCode: 402,
  //无权限code
  unauthorizedCode: 401,
  noPermissionCode: 403,
  needOtpCode: 416,
  //是否开启登录拦截
  loginInterception: true,
  //token失效回退到登录页时是否记录本次的路由
  recordRoute: true,
}
module.exports = setting
